import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/sections`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer toutes les sections
export const getAllSections = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAllSections`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des sections:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour récupérer une section par son id
export const getSectionById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/getSectionById/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la récupération de la section:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// POST
// Fonction pour ajouter une section
export const createSection = async (newSection) => {
  try {
    const response = await axios.post(`${apiUrl}/addSection`, newSection, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 201) throw new Error("Failed to add new section");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de l'ajout d'une section:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// PUT
// Fonction pour modifier une section avec son id
export const updateSection = async (section) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateSection/${section.id}`,
      section,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 200) throw new Error("Failed to update section");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la modification d'une section:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// DELETE
// Fonction pour supprimer une section avec son id
export const deleteSection = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/removeSection/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to delete section");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la suppression d'une section:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};
